import { Link, useLocation } from 'react-router-dom';
import { hubFor } from '../nav.js';

/**
 * The tab strip of a hub (nav.ts HUBS): sibling pages as tabs, and when the
 * current tab holds two pages, a small switch between them. Links, not
 * buttons — every page keeps its own URL. Renders nothing off-hub.
 */
export default function HubTabs(): JSX.Element | null {
  const { pathname } = useLocation();
  const at = hubFor(pathname);
  if (!at || at.hub.tabs.length < 2) return null;
  const { hub, tab, sub } = at;
  return (
    <>
      <nav className="hub-tabs" aria-label={hub.label}>
        <div className="hub-tabs__list">
          {hub.tabs.map((t) => {
            const on = t === tab;
            return (
              <Link
                key={t.to}
                to={t.to}
                aria-current={on ? 'page' : undefined}
                className={`hub-tabs__tab${on ? ' hub-tabs__tab--on' : ''}`}
              >
                {t.label}
              </Link>
            );
          })}
        </div>
      </nav>
      {tab.subs && (
        <div className="hub-subs" aria-label={tab.label}>
          {tab.subs.map((x) => (
            <Link
              key={x.to}
              to={x.to}
              aria-current={x.to === sub ? 'page' : undefined}
              className={`hub-subs__item${x.to === sub ? ' hub-subs__item--on' : ''}`}
            >
              {x.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
